<template>
  <div
    :class="{
      'inline-block': ![
        'smart_delivery_scene_spec',
        'mixed_monetization_spec',
        'smart_delivery_goal_spec'
      ].includes(formKey),
    }"
  >
    <!-- 转化事件 -->
    <div v-if="formKey === 'convert_id'">
      <div class="flex items-center">
        <div v-show="!formItem.isPreview" class="mr-10">
          <el-button type="primary" size="mini" @click="onDataDialog('budget_and_bid_form', 'convert_id', '转化事件目标')">选择转化目标</el-button>
        </div>
      </div>
    </div>
    <!-- 深度优化目标 - 没有值时显示“ - ” -->
    <div v-if="formKey === 'deep_convert_type'">
      <span>{{ formItem.value ? ' ' : '-' }}</span>
    </div>
    <!-- 变现ROI目标 -->
    <div v-if="formKey === 'monetization_converts'">
      <div class="flex items-center">
        <div v-show="!formItem.isPreview" class="mr-10">
          <el-button type="primary" size="mini" @click="onDataDialog('budget_and_bid_form', 'monetization_converts', ' 转化事件-广点通')">选择转化事件</el-button>
        </div>
      </div>
    </div>
    <!-- 付费ROI目标 -->
    <div v-if="formKey === 'purchase_converts'">
      <div class="flex items-center">
        <div v-show="!formItem.isPreview" class="mr-10">
          <el-button type="primary" size="mini" @click="onDataDialog('budget_and_bid_form', 'purchase_converts', ' 转化事件-广点通')">选择转化事件</el-button>
        </div>
      </div>
    </div>
    <!-- 数据弹窗 -->
    <el-dialog
      v-if="data_dialog_config.is_show"
      :title="data_dialog_config.title"
      :visible.sync="data_dialog_config.is_show"
      append-to-body
      width="1200px"
    >
      <component
        :is="data_dialog_config.map_component_name[data_dialog_config.active_name]"
        v-if="data_dialog_config.is_show"
        v-loading="data_dialog_config.is_loading"
        v-bind="data_dialog_config.getters.getProps(data_dialog_config.active_name)"
        @confirm="onDataDialogConfirm"
        @cancel="onDataDialogCancel"
      />
    </el-dialog>
  </div>
</template>

<script>
import { getConvertApi } from '@/api/tool/convert';
import { component_props } from '@/views/fusion/investment/intelligence-create/components/main-view/components/step-form/model/props';
import { data_sharing_mixin } from '@/views/fusion/investment/intelligence-create/mixins/data-sharing';
import { clone } from '@/utils';
import { CHANNEL_INTERFACE_TYPE } from '@/enums';

export default {
  components: {
    'conversion-event': () => import('@/views/fusion/investment/intelligence-create/components/main-view/components/step-form/components/campaign-config/budget-and-bid-form/components/multiple-conversion'),
  },
  mixins: [data_sharing_mixin],
  props: {
    ...component_props,
  },
  data() {
    return {
      // 数据弹窗配置
      data_dialog_config: {
        is_show: false,
        title: '',
        is_loading: false,
        active_name: '',
        map_component_name: {
          convert_id: 'conversion-event',
          purchase_converts: 'conversion-event',
          monetization_converts: 'conversion-event',
        },
        getters: {
          getProps: (active_name) => {
            const map_props = {
              convert_id: {
                tableParams: this.getConvertFiltering(),
                getList: this.getConvertList,
                channelCodesField: this.getChannelCodesField(),
              },
              purchase_converts: {
                tableParams: this.getConvertFiltering(),
                getList: this.getConvertList,
                channelCodesField: this.getPurchaseConvertsChannelCodes(),
              },
              monetization_converts: {
                tableParams: this.getConvertFiltering(),
                getList: this.getConvertList,
                channelCodesField: this.getMonetizationConvertsChannelCodes(),
              },
            };
            return Object.assign(map_props[active_name] || {});
          },
        },
      },
    };
  },
  watch: {
    'formFields.config.delivery_form.config.fusion__channel_code.children.fusion__channel_codes': {
      handler() {
        /**
         * 渠道号变化时清空变现ROI目标、付费ROI目标中转化事件配置信息和value
         */
        const { budget_and_bid_form } = this.formFields.config;
        const { purchase_converts, monetization_converts } = budget_and_bid_form.config;

        monetization_converts.channels_codes = null;
        monetization_converts.value.splice(0);

        purchase_converts.channels_codes = null;
        purchase_converts.value.splice(0);
      },
      deep: true,
    },
  },
  methods: {
    /**
     * 打开数据弹窗
     * @param {string} field_key 表单配置项
     * @param {string} active_name 表单项
     * @param {string} title 弹窗标题
     */
    onDataDialog(field_key, active_name, title) {
      Object.assign(this.data_dialog_config, {
        is_show: true,
        is_loading: false,
        title,
        active_name,
        field_key,
      });
    },
    /**
     * 获取当前配置的渠道字段
     */
    getChannelCodesField() {
      const { delivery_form } = this.formFields.config;
      const { fusion__channel_code } = delivery_form.config;
      const { fusion__channel_codes } = fusion__channel_code.children;
      return fusion__channel_codes;
    },
    /**
     * 删除转化事件中conversion字段
     * @param data 转化事件数据
     */
    handleDeleteConversion(data) {
      (data.value || []).forEach(({ list = [] }) => {
        list.forEach((convert) => {
          delete convert?.conversion;
        });
      });
    },
    /**
     * 获取变现ROI目标渠道字段
     * @return {Object}
     */
    getMonetizationConvertsChannelCodes() {
      const { budget_and_bid_form } = this.formFields.config;
      const { monetization_converts } = budget_and_bid_form.config;
      const init_data = clone(this.getChannelCodesField());
      this.handleDeleteConversion(init_data);
      return monetization_converts.channels_codes || init_data;
    },
    /**
     * 获取付费ROI目标渠道字段
     * @return {Object}
     */
    getPurchaseConvertsChannelCodes() {
      const { budget_and_bid_form } = this.formFields.config;
      const { purchase_converts } = budget_and_bid_form.config;
      const init_data = clone(this.getChannelCodesField());
      this.handleDeleteConversion(init_data);
      return purchase_converts.channels_codes || init_data;
    },
    /**
     * 获取转化目标查询参数
     */
    getConvertFiltering() {
      const { delivery_form } = this.formFields.config;
      const { delivery_content_id, delivery_platform_type } = delivery_form.config;
      const form_context = this.local_sharing_data.getFormContext();
      const { dataController } = form_context.config;
      const channel_interface = dataController.getChannelInterfaceEnum();
      const advertiser_id = dataController.getRequestAdvertiser();

      const strategy = {
        [CHANNEL_INTERFACE_TYPE.GDT]: () => {
          const { marketing_sub_goal } = delivery_form.config;
          return {
            gdt_params: {
              filtering: {
                marketing_sub_goal: marketing_sub_goal.value,
              },
            },
          };
        },
        default: () => {},
      };

      return {
        channel_interface,
        advertiser_id,
        page: 1,
        page_size: 10,
        filtering: {
          ...(delivery_content_id.value && { delivery_content_id: delivery_content_id.value.split('#')[0] }),
          delivery_platform_type: delivery_platform_type.value,
        },
        ...((strategy[channel_interface] || strategy['default'])()),
      };
    },
    /**
     * 获取转化目标
     * @param {Object} params 查询参数
     */
    getConvertList(params) {
      return new Promise((resolve, reject) => {
        getConvertApi(params)
          .then((res) => {
            res.list.forEach((item) => {
              Object.assign(item, { template_data: JSON.stringify(item) });
            });
            resolve(res);
          })
          .catch(reject);
      });
    },
    /**
     * 数据模块确认回调
     * @param {Object} payload 确认数据
     */
    async onDataDialogConfirm(payload) {
      const { field_key, active_name } = this.data_dialog_config;
      const handlers_map = {
        // 转化事件
        convert_id: async() => {
          const { delivery_form } = this.formFields.config;
          const { fusion__channel_code } = delivery_form.config;
          const { fusion__channel_codes } = fusion__channel_code.children;
          const { template_data, channels_codes } = payload;
          const { config } = this.formFields.config[field_key];
          config[active_name].value = template_data;
          Object.assign(fusion__channel_codes, channels_codes);

          /** 优化目标 */
          const fusion__optimize_goal = config.fusion__optimize_goal;

          const { convert_goal, deep_convert_goal } = template_data ? JSON.parse(template_data) : {};
          const { channel_interface } = this.initOps;
          const convert_goal_enum_val = this.$store.getters[`${channel_interface}EnumVal`].api_fusion_convert_goal;
          fusion__optimize_goal.value = convert_goal_enum_val[convert_goal];
          fusion__optimize_goal.hidden = !convert_goal;

          /** 深度优化目标 */
          const deep_convert_type = config.deep_convert_type;
          const enum_val = this.$store.getters[`${channel_interface}EnumVal`].api_fusion_deep_convert_type;
          deep_convert_type.value = enum_val[deep_convert_goal];

          /** 存在转化事件才显示深度优化目标 */
          deep_convert_type.hidden = !config[active_name].value;

          /**
           * 深度优化出价
           * 无深度优化目标选项时或未选择深度优化目标选项时，隐藏此配置项
           * 注：由于广点通媒体支持多个转化事件选取，当其中一个转化事件包含深度优化目标时，即视为存在‘深度优化目标’
           */
          const price_strategy = config.price_strategy;

          /** 出价策略是否是最大转化投放 */
          const is_max = price_strategy.value === 'BID_SCENE_NORMAL_MAX';

          /** 所有分配的转化是否存在深度优化目标 */
          const ret = Object.values(channels_codes.value).reduce((pre, cur) => {
            return pre.concat(cur.list);
          }, []).filter(code => {
            // 当其中一个转化事件包含深度优化目标时，即视为存在‘深度优化目标’
            return code.conversion && JSON.parse(code.conversion).deep_convert_goal;
          });

          /** 那就是存在任意一个转化存在深度目标且有一个转化存在is_ori 为true 就显示深度优化ROI 系数出价 */
          const valid_roi = ret.length > 0 && ret.some(convert => {
            return !!JSON.parse(convert.conversion).gdt_params?.is_roi;
          });

          /** 那就是存在任意一个转化存在深度目标且有一个转化存在is_ori 为 false 就显示深度优化出价 */
          const valid_behavior = ret.length > 0 && ret.some(convert => JSON.parse(convert.conversion).gdt_params?.is_roi === false);

          const is_ocpm = config.price_type.value === 'BID_MODE_OCPM';
          /**
           * 存在深度优化目标且且有一个转化存在is_ori 为 false, 且出价策略非最大转化投放
           */
          config.deep_convert_price.hidden = !(valid_behavior && (!is_max && !price_strategy.hidden)) || !is_ocpm;

          /**
           * 深度ROI系数出价
           * deep_convert_worth_rate
           * 那就是存在任意一个转化存在深度目标且有一个转化存在is_ori 为true 就显示深度优化ROI 系数出价
           */
          /** 存在深度优化目标且有一个转化存在is_ori 为true 出价策略非最大转化投放 */
          config.deep_convert_worth_rate.hidden = !(valid_roi && (!is_max && !price_strategy.hidden)) || !is_ocpm;

          this.onDataDialogCancel();
          this.$parent.$parent.$parent.validateField('convert_id.value');
        },
        /** 变现ROI目标 */
        monetization_converts: () => {
          const { channels_codes } = payload;
          const { config } = this.formFields.config[field_key];
          config[active_name].channels_codes = clone(channels_codes);
          config[active_name].value = this.transformConvertsPayload(channels_codes.value);
          this.onDataDialogCancel();
          this.$parent.$parent.$parent.validateField('monetization_converts.value');
        },
        /** 付费ROI目标 */
        purchase_converts: () => {
          const { channels_codes } = payload;
          const { config } = this.formFields.config[field_key];
          config[active_name].channels_codes = clone(channels_codes);
          config[active_name].value = this.transformConvertsPayload(channels_codes.value);
          this.onDataDialogCancel();
          this.$parent.$parent.$parent.validateField('purchase_converts.value');
        },
      };
      await handlers_map[active_name]?.();
      this.onDataDialogCancel();
    },

    async onDataDialogCancel() {
      Object.assign(this.data_dialog_config, { is_show: false, is_loading: false, title: '', active_name: '', field_key: '' });
    },
    /**
     * 转化事件数据转换
     * @param {Array} channels_codes 转化事件数据
     * @returns {Array}
     */
    transformConvertsPayload(channels_codes = []) {
      return channels_codes.map(channels_code => {
        /** 过滤空的转化事件 */
        const converts = channels_code.list.filter(({ conversion }) => !!conversion);
        return {
          /** 广告主 ID */
          advertiser_id: channels_code.advertiser_id,
          /** 转化 */
          converts: converts.map(convert => {
            const { alias: channel_alias } = convert;
            const {
              id,
              name,
              convert_goal,
              deep_convert_goal: deep_convert_type,
              gdt_params: {
                is_roi,
              } = {},
            } = JSON.parse(convert.conversion);
            return {
              /** 转化 ID */
              ...(id && { id }),
              /** 转化名称 */
              ...(name && { name }),
              /** 渠道号 */
              ...(channel_alias && { channel_alias }),
              /** 优化目标 */
              ...(convert_goal && { convert_goal }),
              /** 深度优化类型 */
              ...(deep_convert_type && { deep_convert_type }),
              /** 是否 roi */
              ...(is_roi && { is_roi }),
            };
          }),
        };
      });
    },
  },
};
</script>

<style lang="scss">
.step-form-wrapper {
  .smart-delivery-goal {
    display: none;
  }
}
</style>
